/**
 *
 * Multistep Form UI
 *
 * UI for handling the logic for showing the multistep form journey
 * NOTE: the logic of this form varies enough that it made sense to separate
 * from contact-download_form.js
 */

const $ = require( 'jquery' );
const _LStorage = require('./utilities/_LStorage.js');
const _Forms = require('./utilities/_form-controller.js');
const Deckable2 = require( './utilities/deckable2.js' );
const { Foundation, dataLayer, ITBL } = window;
const _ = require("lodash");
const FormDropOff = require("./utilities/FormDropOff");
const kickboxCheck = require("./src/run/kickbox/kickboxCheck");
const disableSubmitButtonInForm = require('./src/run/form/disableSubmitButtonInForm');
const Form_init = require("./src/Form_init");

class MultiStepForm{

  constructor(el){
    this.$el = $(el);
    this.$form = this.$el.find('.itbl-b-form');
    this.FormInstance = new Foundation.Abide(this.$form, {
      //validateOnBlur : true
    });

    //next and previous buttons
    this.$step1__next = this.$el.find( '.itbl-c-multiform__step1-next' );
    this.$step2__previous = this.$el.find( '.itbl-c-multiform__step1-previous' );

    //form steps
    //targeting the form steps through the deckable attr, so that we're sure to have this element consistent across uses
    this.$form__step1 = this.$el.find('[data-deckable2="form"]');
    this.$form__step2 = this.$el.find('[data-deckable2="form-step2"]');

    //special inputs that need to be watched for
    this.$emailInput = this.$el.find( '[name=Email]' );
    this.$marketingConsent = this.$form.find('[name=marketingConsent]');
    this.$privacyPolicy = this.$form.find('#iterables-privacy-policy');
    this.$countrySelect = this.$form.find('.itbl-b-select__country');

    //additional hidden fields
    this.$usStatesSelect = this.$form.find('.itbl-b-select__us_state_wrap');
    this.$canadaStatesSelect = this.$form.find('.itbl-b-select__canada_state_wrap');

    //known user elements
    this.$userName = this.$el.find('.itbl-c-form__username');
    this.$returningUserCTA = this.$el.find('.itbl-c-form__known-user-cta');
    this.$userEmailEl = this.$el.find('.itbl-c-form__user-email');


    //success message SVG classes
    this.$confirmation = this.$el.find('.itbl-c-form__confirmation');
    this.$confirmationWrap = this.$el.find('.itbl-b-form__confirmation-overflow');

    this.$downloadImg = this.$el.find('.itbl-c-form__download-img');

    //these fields and event directly relate to the contact
    this.isContact = this.$form.hasClass('itbl-c-form-contact');
    this.$returningContactCTA = this.$el.find('.itbl-c-form__known-user-contact');
    this.enable_knownUser  = ( Object.prototype.hasOwnProperty.call( ITBL, 'enable_known_user') );

    //get the user email from localstorage
    this.userEmail = _LStorage.decrypt__get('iterable/encrypted/Email');
    this.userFirstName = _LStorage.decrypt__get('iterable/encrypted/FirstName');
    this.userLastName = _LStorage.decrypt__get('iterable/encrypted/LastName');

    this.APIState = Object.assign(
      {},
      {
        wp_email_to: 'forms@iterable.com',
        wp_email_subject: document.title,
        wp_email_message: null, //we gotta build this message body
        listUpload: true,
      }
    );

    /**
     * Super important Variable that controls form submission
     * @type {boolean}
     */
    this.canSubmit = false;
    this.canMoveToStep2 = false;

    //init the deckable class and turn on the loading spinner
    this.deckable = new Deckable2(this.$el, {})
      .showHideLoading(true);

    this.init();
    this.events();

    this.kickboxCheck = this.kickboxCheck.bind(this);

    if (this.isDemoForm()) {
      this.APIState.Email_Verification_Status__c = '';
      this.APIState.kickboxReason = '';
      this.$emailInput.on(
        'change',
        e => this.kickboxCheck($(e.currentTarget).val())
      );
    }

    this.formDropOff = new FormDropOff(this.$form);

    this.deckable.goToDeck('form');

    Form_init(this.$form[0]);
  }

  isDemoForm () { return this.$form.find('[name=formid]').val() === '1122' }

  async kickboxCheck (email) {
    const kickboxResponse = await kickboxCheck(email);
    this.APIState.Email_Verification_Status__c = kickboxResponse.result;
    this.APIState.kickboxReason = kickboxResponse.reason;
  }

  init(){
    //remove required fields from step 2 elements
    this.event__step2Required('remove');
  }

  submit () {
    // WARNING: It seems that an autofill tool is changing the State field
    // Do not wonder why this is here
    if (
      this.$usStatesSelect.css("display") === "none" &&
      this.$canadaStatesSelect.css("display") === "none"
    ) {
      this.APIState.State = "";
    }

    this.event__validFrom(this.$form[0]);
  }

  events(){
    //events

    this.$form
      .on('submit', e => {
        e.preventDefault()

        if (!this.canSubmit) {
          console.log('No submitting allowed')
          return false
        }

        this.submit();
      })
      .on('forminvalid.zf.abide', ()=>{
        this.canMoveToStep2 = false;
        this.canSubmit = false;
      })
      // field element is invalid
      .on("invalid.zf.abide", ()=> {
        this.$form__step1.attr('disabled');
      })
      // field element is valid
      .on("valid.zf.abide", ()=>{

      })
      .on('formvalid.zf.abide', ()=>{
        this.canMoveToStep2 = true;
        this.canSubmit = true;
      });

    this.$step1__next.on('click', this.event__goToNextStep.bind(this) );

    this.$step2__previous.on('click', this.event__goBackAStep.bind(this) );

    //shows the confirmation deck on CONF keyCode
    _Forms.event__keyCodeFn([67, 79, 78, 70], () => {
      this.deckable.goToDeck('confirmation');
    });

    _Forms.event__keyCodeFn( [50, 83, 84], ()=>{
      this.deckable.goToDeck('form-step2');
    } );

    // show hidden selects, if specific country selected
    this.$countrySelect.on( 'change', this.event__countrySelected.bind(this) );

  }

  triggerProcess( target ){

    if( !( target ) ){
      console.log( 'No target provided' );
      return;
    }

    //create the net instance of the event and assign it to be watched by the Process script
    let event = new Event("itblProcess.goToStep", {
      bubbles: true,
    });

    //update the target information, that the process script needs to locate it's target
    event.detail = {
      target: target
    };

    //dispatch
    this.$el[0].dispatchEvent(event);
  }

  async event__validFrom() {

    //hide all decks
    this.deckable.hideAllDecks();

    //serialize this data into name/value
    await _Forms.helper__addFormInputsToState(this.$form, this.APIState);

    if (this.isDemoForm() && !this.APIState.Email_Verification_Status__c) {
      try {
        await this.kickboxCheck(this.APIState.Email);
      } catch (e) {
        console.error("Kickbox error", e);
      }
    }

    //we have to manually check for this field to be checked
    if (this.$privacyPolicy.is(':checked')) {

      this.APIState.marketingConsent = 'true';
      this.$marketingConsent.val('true');

    } else {
      //if checkbox is not checked, explicitly set value to false as string, this will be converted into boolean by JSON
      this.APIState.marketingConsent = 'false';

    }

    //setup all encrypted values in localstorage
    _Forms.helper__setAllEncryptedVals(['FirstName', 'LastName', 'Email', 'Phone', 'marketingConsent'], this.APIState);

    //replace the text with the user's name
    $(this.$userName).text(this.APIState.FirstName);

    // NOTE: Something sets the State to "; ". This needs to be stripped to ""!!

    if (this.APIState.HQ_State__c === "; ") {
      this.APIState.HQ_State__c = "";
    }

    if (this.APIState.State === "; ") {
      this.APIState.State = "";
      this.$form.find("[name=State]").val(this.APIState.State);
    }

    if (!this.APIState.HQ_Country__c && !this.APIState.HQ_State__c) {
      this.APIState.HQ_Country__c = this.APIState.Country;
      this.APIState.HQ_State__c = this.APIState.State;
    }

    if (!_.includes(
      ["United States", "Canada"],
      this.APIState.HQ_Country__c
    )) {
      this.APIState.HQ_State__c = "";
    }

    this.$form.find("[name=HQ_Country__c]").val(this.APIState.HQ_Country__c);
    this.$form.find("[name=HQ_State__c]").val(this.APIState.HQ_State__c);

    disableSubmitButtonInForm(this.$form[0]);

    // chiliPiperFormId: "demo" - Take a look inside _form-controller.js to figure out why.
    // The form id is being overwritten with the data-formtype. This is probably because of Setka 1122 forms.
    _Forms.marketo__submit(this.APIState, false, {chiliPiperFormId: "demo"}, this.$form)
      .then(() => {

        //trigger Google Tag Manager event for Adwords conversion here!
        dataLayer.push({'event': 'ajaxFormSubmitted'});
        this.formDropOff.send(true);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {

        //disallow forms to submit again
        this.canSubmit = false;

        _Forms.debug( 'finished API state', this.APIState );


        //even though this submission failed, we are jumping to success anyway
        this.deckable
          .goToDeck('confirmation');

        //trigger the finish slide: the finished deck is #2
        this.triggerProcess( 2 );

      });

    return false;

  }

  /**
   * Goes to the form deck
   * @param event
   */
  event__goToForm(event) {

    event.preventDefault();

    this.deckable.goToDeck('form');

  }

  /**
   *
   * on the next button, runs the validation for the form
   * if everything is OK, then it goes to step 2 of the form, and and allows the form to submit
   *
   * @param event
   */
  event__goToNextStep (event) {
    event.preventDefault();

    this.$form.foundation('validateForm');

    if (this.canMoveToStep2) {
      this.formDropOff.send(false);
      this.deckable.goToDeck('form-step2');
      this.triggerProcess('1');
      this.event__step2Required('add');
    } else {
      console.log('cannot submit');
    }


  }

  /**
   *
   * handles the going-back functionality when on the second level
   *
   * @param event
   */
  event__goBackAStep(event){

    event.preventDefault();

    this.deckable.goToDeck('form');

    this.triggerProcess( '0' );

    this.event__step2Required('remove');
  }

  /**
   *
   * handles showing/hiding US and Canada states select field 
   *
   * @param event
   */
  event__countrySelected(event) {
    let selectedCountry = event.target.value;

    if(selectedCountry === "Canada") {
      this.$canadaStatesSelect.css({ display: "initial" });
      this.$usStatesSelect.css({ display: "none" });
      
      this.$canadaStatesSelect.find('.itbl-b-select__canada_state').attr("name", "State");
      this.$canadaStatesSelect.find('.itbl-b-select__canada_state').attr("required", true);

      this.$usStatesSelect.find('.itbl-b-select__us_state').attr("name", "State_us");
      this.$usStatesSelect.find('.itbl-b-select__us_state').removeAttr("required");
    } else if(selectedCountry === "United States") {
      this.$usStatesSelect.css({ display: "initial" });
      this.$canadaStatesSelect.css({ display: "none" });
      
      this.$usStatesSelect.find('.itbl-b-select__us_state').attr("name", "State");
      this.$usStatesSelect.find('.itbl-b-select__us_state').attr("required", true);

      this.$canadaStatesSelect.find('.itbl-b-select__canada_state').attr("name", "State_ca");
      this.$canadaStatesSelect.find('.itbl-b-select__canada_state').removeAttr("required");
    } else {
      this.$usStatesSelect.css({ display: "none" });
      this.$canadaStatesSelect.css({ display: "none" });

      this.$usStatesSelect.find('.itbl-b-select__us_state').removeAttr("required");
      this.$canadaStatesSelect.find('.itbl-b-select__canada_state').removeAttr("required");

      this.$usStatesSelect.find('.itbl-b-select__us_state').prop('selectedIndex', 0);
      this.$canadaStatesSelect.find('.itbl-b-select__canada_state').prop('selectedIndex', 0);
    }
  }

  /**
   * handles required fields on step 2
   * 
   * @param action
   */
  event__step2Required(action){
    //required fields on step 2 need to have class '.itbl-b-input__required-step-2'
    this.$requiredFieldsStep2 = this.$form.find('.itbl-b-input__required-step-2');

    if(action === 'add'){

      this.$requiredFieldsStep2.each(field => {
        $(this.$requiredFieldsStep2[field]).attr('required', true);
      });

    } else if(action === 'remove'){

      this.$requiredFieldsStep2.each(field => {
        $(this.$requiredFieldsStep2[field]).removeAttr('required');
      });

    }
  }
}

$(document).ready(function(){
  $('.js-multiform-ui-init').each(function(){
    new MultiStepForm(this);
  });

});
